<template>
	<div>
		<el-container>
			<el-header >
				<el-form :inline="true" >
					
					<el-form-item>
						<el-upload
							class="upload-demo" ref="upload" accept=".xls,.xlsx"
							:action="this.publicPath + '/uploads/'"
							:on-change="upload"
							:show-file-list="false"
							:auto-upload="false"
							:file-list="excelFileList"
							>
							<el-button type="primary" >选择文件</el-button>
						</el-upload>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="dialogVisible = true">导入名单</el-button>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="dialogVisible = true">下载模板</el-button>
					</el-form-item>
					<el-form-item>
						<div slot="tip" class="el-upload__tip">{{ excelFileName }}</div>
					</el-form-item>
				</el-form>
			</el-header>

			
			<el-main>
				<el-table
						ref="multipleTable"
						:data="excelData"
						tooltip-effect="dark"
						style="width: 100%; margin-top: -20px;"
						:height="tableHeight"
						:row-style="{height: '0px'}"
						:cell-style="{padding: '2px'}"
						:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
						border
						stripe
						@selection-change="handleSelectionChange">

					<el-table-column
							type="selection"
							width="55">
					</el-table-column>

					<el-table-column
							prop="personNo"
							label="人员编号"
							show-overflow-tooltip
							width="130">
					</el-table-column>

					<el-table-column
							prop="personName"
							label="姓名"
							show-overflow-tooltip
							width="120">
					</el-table-column>

					<el-table-column
							prop="personSex"
							label="性别"
							width="80">
							<template slot-scope="scope">
							<el-tag size="small" v-if="scope.row.personSex === 1" type="success">男</el-tag>
							<el-tag size="small" v-else-if="scope.row.personSex === 0" type="danger">女</el-tag>
							<el-tag size="small" v-else type="danger">未知</el-tag>
						</template>
					</el-table-column>

					<el-table-column
							prop="identityName"
							label="身份"
							show-overflow-tooltip
							width="100">
					</el-table-column>

					<el-table-column
							prop="fullName"
							label="部门"
							show-overflow-tooltip>
					</el-table-column>
					
					<el-table-column
							prop="idNo"
							label="证件号码"
							show-overflow-tooltip>
					</el-table-column>

					<!-- <el-table-column
							prop="cardSerial"
							label="卡号"
							show-overflow-tooltip>
					</el-table-column> -->
					
					<el-table-column
							prop="endDate"
							label="有效日期"
							show-overflow-tooltip
							width="120">
					</el-table-column>

					<el-table-column
							prop="statusFlag"
							label="状态"
							width="100">
						<template slot-scope="scope">
							<el-tag size="small" v-if="scope.row.statusFlag === 1" type="success">正常</el-tag>
							<el-tag size="small" v-else-if="scope.row.statusFlag === 0" type="danger">禁用</el-tag>
						</template>

					</el-table-column>

					<el-table-column
							prop="icon"
							label="操作"
							width="120">

						<template slot-scope="scope">

							<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
							<el-button type="text" @click="editPersonCard(scope.row)">绑卡</el-button>
							
							<!--<el-divider direction="vertical"></el-divider>

								<template>
								<el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id)">
									<el-button type="text" slot="reference">删除</el-button>
								</el-popconfirm>
							</template> -->

						</template>
					</el-table-column>

				</el-table>

				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						layout="total, sizes, prev, pager, next, jumper"
						:page-sizes="[10, 20, 50, 100]"
						:current-page="current"
						:page-size="size"
						:total="total">
				</el-pagination>
			</el-main>
			
		</el-container>
	</div>
</template>

<script>
	export default {
		name: "PersonImport",
		data() {
			return {
				publicPath: process.env.BASE_URL,
				searchForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {

				},
				cardDialogVisible: false,
				cardForm: {},

				tableData: [],
				cardData: [],
				excelData: [],

				excelFileName:'',
				excelFileList: [],

				selectedIdentityId:'',
				identityList:[],

				editFormRules: {
					personNo: [
						{required: true, message: '请输入人员号', trigger: 'blur'}
					],
					personName: [
						{required: true, message: '请输入姓名', trigger: 'blur'}
					],
					personSex: [
						{required: true, message: '请选择性别', trigger: 'blur'}
					],
					identityId: [
						{required: true, message: '请选择身份', trigger: 'blur'}
					],
					deptId: [
						{required: true, message: '请选择部门', trigger: 'blur'}
					]
				},

				multipleSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'personName'
				},
				permTreeData: [],
				treeSelectDeptId: 0,
				selectedPersonInfo: '',
				newCardSerail: '',
				bindCardPersonId: ''
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 630: 550
			}
		},
		created() {
			this.getPersonList()
			this.getIdentityList()

			this.$axios.get('/base/person/list').then(res => {
				this.permTreeData = res.data.data
			})
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				// ("勾选")
				// console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.size = val
				this.getPersonList()
			},
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.current = val
				this.getPersonList()
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			resetCardForm() {
				this.cardDialogVisible = false
				this.cardForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},
			handleCardFormClose() {
				this.resetForm('cardForm')
			},
			deptSelectNodeClick(deptdata) {
				this.$set(this.editForm, "deptId", deptdata.id);
				this.$set(this.editForm, "fullName", deptdata.fullName);
				// console.log(deptdata);
			},

			getPersonList() {
				this.$axios.get("/base/person/list", {
					params: {
						code: this.searchForm.code,
						name: this.searchForm.name,
						card: this.searchForm.card,
						deptId: this.treeSelectDeptId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			getIdentityList() {
				this.$axios.get("/base/identity/list", {
					// params: {
					// 	name: this.searchForm.name,
					// 	current: this.current,
					// 	size: this.size
					// }
				}).then(res => {
					this.identityList = res.data.data.records
				})
			},

			getCardList() {
				this.$axios.get("/base/card/list", {
					params: {
						personId: this.bindCardPersonId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.cardData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.editForm);
						this.$axios.post('/base/person/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
									onClose:() => {
										this.getPersonList()
									}
								});

								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(id) {
				this.$axios.get('/base/person/info/' + id).then(res => {
					this.editForm = res.data.data

					this.dialogVisible = true
				})
			},
			editPersonCard(row) {
				this.bindCardPersonId = row.id;
				this.selectedPersonInfo = row.personNo + "(" + row.personName + ") 卡片绑定";
				this.newCardSerail = ''
				this.getCardList()
				this.cardDialogVisible = true
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				console.log(ids)

				this.$axios.post("/base/person/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getPersonList()
						}
					});
				})
			},
			bindCardHandle() {
				this.$axios.post('/base/card/bind/' + this.bindCardPersonId, this.newCardSerail)
							.then(res => {

								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
									onClose:() => {
										this.getCardList()
									}
								});
							})
			},
			unBindCardHandle(id) {
				this.$axios.post("/base/card/unbind", id).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getCardList()
						}
					});
				})
			},
			upload (file) {
				console.log('选择文件：' + file)
				console.log('文件列表：' + this.excelFileList)
				const files = {0: file.raw}
				this.excelFileName = files.name
				this.readExcel(files)
			},
			readExcel(files) {
				if (files.length <= 0) {
					return false
				} else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
					this.$message.error('选择文件格式不正确，请选择xls或者xlsx文件')
					return false
				}

				const fileReader = new FileReader()
				fileReader.onload = (files) => {
					try {
						const data = files.target.result
						const workbook = xlsx.read(data, {
							type: 'binary'
						})
						const wsname = workbook.SheetNames[0] // 取第一张表
						const ws = xlsx.utils.sheet_to_json(workbook.Sheets[wsname]) // 生成json表格内容
						consonle.log(ws, 'ws是表格里的数据，且是json格式')
						this.excelData = ws
						// 重写数据
						this.$refs.upload.value = ''
					} catch (e) {
						console.log('选择excel文件异常，' + e)
						return false
					}
				}
				fileReader.readAsBinaryString(files[0])
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
	.el-select {
		width: 96%;
	}

</style>